<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div id="irrmap" style="height: 450px"></div>
</template>

<script>
    export default {
      props: {
        route: String,
        irrs: Array, //multiple resources
        activeIrrId: Number,
      },
      data() {
        return {
          map: false,
          areaOfAuthority: false,
          irrMarker: false,
          currentLat: 0,
          currentLng: 0,
          currentIrr: 0,
          componentMounted: false,
        }
      },
      watch: {
        //watch for activeIrrId changes
        activeIrrId: function () {
          this.changeActiveIrr(this.activeIrrId);
        }
      },
      mounted: function () {
        this.$nextTick(function () {  //don't run until the entire view has been rendered
          //init the current irr
          this.currentIrr = (typeof this.irrs[0] != 'undefined') ? this.irrs[0].irrs : false;

          //init current Lat Lng
          if(this.currentIrr) {
            this.currentLat = this.currentIrr.latitude;
            this.currentLng = this.currentIrr.longitude;
          }

          //init the map
          this.map = window.L.map('irrmap').setView([39.8, -98.6], 4); //default to United States view
          //this.map.dragging.disable(); //disable panning

          //add the content
          //L.tileLayer('/map/tile/{s}/{id}/{z}/{x}/{y}', {  //for use when proxying the tile requests

          /* DEPRECATED L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
      			attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/" target="_blank">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/" target="_blank">CC-BY-SA</a>',
      			maxZoom: 18,
            minZoom: 3,
      			id: 'mapbox.streets',
      			accessToken: 'pk.eyJ1IjoiamRvbm5lbGwiLCJhIjoiY2ptZHN1azhqMHR2MDNxbnF2eWloOTRoeSJ9.RlFLdSY8e_anTpJNUJhIkA',
      		}).addTo(this.map); */

          L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
            tileSize: 512,
            maxZoom: 18,
            minZoom: 3,
            zoomOffset: -1,
            id: 'jdonnell/ckg9vp1o403lx1as8i81og3ir',
            accessToken: 'pk.eyJ1IjoiamRvbm5lbGwiLCJhIjoiY2ptZHN1azhqMHR2MDNxbnF2eWloOTRoeSJ9.RlFLdSY8e_anTpJNUJhIkA'
          }).addTo(this.map);

          window.L.control.scale().addTo(this.map);

          //update map elements for the irr
          this.updateIrrOnMap();

          this.componentMounted = true;
        })
      },
      methods: {
        //called when the user has changed the active irr (e.g. clicked an irr on the page)
        changeActiveIrr: function($id) {
          for(var i=0; i<this.irrs.length; i++) {
            if(this.irrs[i].irr_id == $id && this.irrs[i].irrs != 'undefined') {
              this.currentIrr = this.irrs[i].irrs;
              this.currentLat = this.currentIrr.latitude;
              this.currentLng = this.currentIrr.longitude;
              this.updateIrrOnMap();
            }
          }
        },
        //update map elements based on the currently active irr
        updateIrrOnMap: function() {
          //update map setView
          if(this.map && this.currentIrr) {  //if there is a currently selected irr and a map
            this.map.setView([this.currentLat, this.currentLng], 16);

            if(this.areaOfAuthority) {
              this.map.removeLayer(this.areaOfAuthority)  //remove the current area of authority
            }
            //draw a circle for the IRR's area of coverage
            this.areaOfAuthority = L.circle([this.currentLat, this.currentLng], {
        			color: 'orange',
        			fillColor: '#ffa200',
        			fillOpacity: 0.1,
        			radius: this.currentIrr.radius
        		}).addTo(this.map);

            if(this.irrMarker) {
              this.map.removeLayer(this.irrMarker) //remove the current marker
            }

            //add marker for the irr
            this.irrMarker = L.marker([this.currentLat, this.currentLng]).addTo(this.map);

            //create a popup and bind it to the marker
            var popupURL = '/irr/' + this.currentIrr.id;
            var popupButtonText = 'View Registry';


            var irrPopup = '<h4>' + this.currentIrr.name + '</h4><p class="lead">' + this.currentIrr.description + '</p>';
            irrPopup += '<center><a type="button" class="btn btn-registry btn-sm" href="' + popupURL + '">' + popupButtonText + '</a></center>';
            this.irrMarker.bindPopup(irrPopup);

            //fire a click event on the marker to display the popup immediately
            this.irrMarker.fireEvent('click');


            //scroll page back to map
            if(this.componentMounted) { //only run for index view and don't run on initial load of the page/map
              $('html, body').animate({
                  scrollTop: ($('#irrmap').first().offset().top)
                },500);
            }
          } else {
            this.areaOfAuthority = false;
            this.irrMarker = false;
          }
        },  //end function
      },    //end methods
    }
</script>
